import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";
import { trackAuditCta } from "@/tracking/analytics";
import { useBooking } from "./BookingProvider";

export const FinalCTA = () => {
    const openBooking = useBooking();

    return (
        <section className="py-28 md:py-36 lg:py-44 relative overflow-hidden">
            <div
                aria-hidden="true"
                className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[480px] w-[720px] bg-brass-500/[0.05] blur-[130px] rounded-full pointer-events-none"
            />
            <div className="shell relative text-center max-w-3xl mx-auto">
                <Reveal>
                    <h2 className="font-serif font-medium text-3xl sm:text-4xl lg:text-6xl tracking-tight leading-[1.12] text-white">
                        Ready to make paid search work harder for your firm?
                    </h2>
                </Reveal>
                <Reveal delay={0.12}>
                    <p className="mt-7 text-base lg:text-lg leading-relaxed text-zinc-400">
                        Let's identify the opportunities in your current
                        acquisition strategy.
                    </p>
                </Reveal>
                <Reveal delay={0.2}>
                    <a
                        href="#book"
                        data-testid="final-cta-button"
                        onClick={(e) => {
                            e.preventDefault();
                            trackAuditCta("final-cta");
                            openBooking();
                        }}
                        className="btn-brass group mt-11"
                    >
                        Explore My Options
                        <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                    </a>
                </Reveal>
            </div>
        </section>
    );
};

export default FinalCTA;
